import {Component, SimpleChanges} from '@angular/core';
import {DataSharingService} from '../../services/data-sharing/data-sharing.service';
import { BikeCategoryExtendedOptions} from '../../services/module/BikeCategory';

@Component({
  selector: 'app-ride-fahrrad',
  templateUrl: './ride-fahrrad.component.html',
  styleUrls: ['./ride-fahrrad.component.scss'],
})
export class RIDEFahrradComponent {

  constructor(public dSS: DataSharingService) {}
  public bikeCategoryOptions = [
    { value: 0, display: 'Pedelec / E-Bike ' },
    { value: 1, display: 'Fahrrad' },
  ];


  update(changes: any): void{
    this.dSS.inputChanged.next(true);
  }

  getBikeCategoryOptions(): any {
    return this.dSS.isVivantes() ? BikeCategoryExtendedOptions : this.bikeCategoryOptions;
  }
}
